import { consola } from 'consola'

export function useExtractLink(string: string): string {
  return string.split('"').find((value) => value.includes('https')) as string
}

export function useExtractLinkFromHtml(htmlString: string) {
  const link = htmlString.split('href=')[1]?.split('>')[0]?.replace(/"/g, '')
  if (!link) {
    consola.error({
      message: 'No link found in html string',
      html: htmlString,
    })
  }
  return link ?? ''
}
